import React, { Component } from 'react'

export default class Download extends Component {
  render() {
    return (
        <svg
        width={47}
        height={47}
           xmlns="http://www.w3.org/2000/svg"
           data-name="Ebene 1"
           viewBox="0 0 800 800"
           version="1.1"
           id="svg22">
          
          <defs
             id="defs10">
            <clipPath
               id="d">
              <circle
                 cx="400"
                 cy="400"
                 r="400"
                 fill="none"
                 id="circle2" />
            </clipPath>
            <linearGradient
               id="c"
               x1="470.16"
               x2="167.15"
               y1="348.16"
               y2="651.16"
               gradientUnits="userSpaceOnUse">
              <stop
                 offset="0"
                 id="stop5" />
              <stop
                 stop-opacity="0"
                 offset="1"
                 id="stop7" />
            </linearGradient>
          </defs>
          <circle
             cx="400"
             cy="400"
             r="400"
             fill="#1c8adb"
             id="circle12"
             style={{fill:'#ffa500'}} />
          <path  id="path9"
             d="m 392.11719,146.76758 c -18.27566,-0.21646 -31.99511,19.95478 -27.73633,37.11523 0,76.57683 0,153.15365 0,229.73047 -18.87366,-19.03206 -36.48317,-39.93394 -59.11524,-54.67773 -20.42753,-6.8534 -42.9624,17.37513 -33.83203,37.15429 11.43476,19.91099 31.72558,32.23999 46.26435,49.57998 21.2426,21.37417 41.25006,44.41024 65.75323,62.17393 19.50648,7.32811 42.10319,-13.30816 37.06836,-33.38672 -0.65072,-102.59174 1.43372,-205.23636 -1.17773,-307.79297 -3.38001,-11.64738 -15.10909,-20.1951 -27.22461,-19.89648 z"
             style={{fill:'#ffffff'}} />
          <path
             id="path11"
             d="m 392.11719,146.76758 c -18.28373,-0.21934 -32.00684,19.97329 -27.72657,37.13672 0.70814,101.98414 -1.54764,204.0188 1.26758,305.96875 5.66172,20.91885 38.08726,25.91733 49.88086,7.78906 32.41421,-33.88737 68.09358,-64.76014 97.99414,-100.98047 9.32854,-19.84951 -13.26915,-44.86558 -33.95508,-37.47656 -19.56068,8.93217 -30.56607,28.74194 -46.88238,41.87197 -3.80979,3.08153 -9.6295,11.03222 -12.24958,11.23155 -0.33774,-81.87582 1.3269,-163.8063 -1.10436,-245.64454 -3.38001,-11.64738 -15.10909,-20.1951 -27.22461,-19.89648 z M 149.66211,405.75195 c -18.27362,-0.1715 -31.95251,20.03535 -27.63477,37.1836 0.99295,58.7966 -2.26544,117.7414 1.86524,176.43554 6.002,15.28405 24.73625,20.64263 39.70312,17.7397 159.63571,-0.55097 319.30866,1.21149 478.91992,-1.00141 16.05136,-4.44138 23.83951,-23.46446 20.36329,-38.82227 -0.83705,-57.81766 1.99626,-115.7394 -1.64649,-173.48242 -6.54268,-21.29475 -40.8203,-23.98484 -50.72656,-4.0918 -7.95936,19.87905 -1.42226,41.7386 -3.74219,62.25 0,33.0013 0,66.0026 0,99.00391 -142.90234,0 -285.80469,0 -428.70703,0 -0.52457,-52.12906 1.76748,-104.36102 -1.45312,-156.41602 -3.75583,-11.14019 -15.19855,-19.09819 -26.94141,-18.79883 z"
             style={{fill:'#ffffff'}} />
        </svg>
        
     
    )
  }
}
